import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "components/library/Button";
import HeaderDropdown from "../HeaderDropdown";
import Icon from "components/library/Icon";

import styles from "./NewItemDropdown.css";

export default class NewItemDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isDropdownOpen: false };
    this.openDropdown = this._openDropdown.bind(this);
    this.closeDropdown = this._closeDropdown.bind(this);
  }

  _openDropdown() {
    this.setState({ isDropdownOpen: true });
  }

  _closeDropdown() {
    this.setState({ isDropdownOpen: false });
  }

  render() {
    const dropdown = (
      <HeaderDropdown
        isOpen={this.state.isDropdownOpen}
        closeDropdown={this.closeDropdown}
        items={this.props.items}
      />
    );

    return (
      <div className={classNames(styles.root, "gtm-new-content")}>
        <Button
          className={styles.buttonGroup}
          onClick={this.openDropdown}
          type="tertiary"
          data-cy="newButton"
        >
          <Icon name="plus" className={styles.plus} />
          <span>New</span>
          <Icon name="chevron-down" className={styles.chevronDown} />
        </Button>
        {this.state.isDropdownOpen ? dropdown : null}
      </div>
    );
  }
}

NewItemDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      children: PropTypes.node,
      to: PropTypes.string.isRequired,
    })
  ).isRequired,
};
